import { gql } from '@apollo/client'

const KEY_PERFORMANCE_METRICS_QUERY = gql`
  query keyPerformanceMetrics(
    $stationIds: [ID!]!
    $fuelGradeIds: [ID!]!
    $metricNames: [String!]!
    $currentPeriodStartDate: String
    $currentPeriodEndDate: String
    $timeResolution: String
    $groupByStation: Boolean
    $groupByFuelGrade: Boolean
    $page: Int!
  ) {
    keyPerformanceMetrics(
      input: {
        stationIds: $stationIds
        fuelGradeIds: $fuelGradeIds
        metricNames: $metricNames
        currentPeriodStartDate: $currentPeriodStartDate
        currentPeriodEndDate: $currentPeriodEndDate
        timeResolution: $timeResolution
        groupByStation: $groupByStation
        groupByFuelGrade: $groupByFuelGrade
        page: $page
      }
    ) {
      dates
      stationNames
      fuelGradeNames
      metrics
      pageInfo {
        page
        pageSize
        totalItems
        totalPages
      }
    }
  }
`

export { KEY_PERFORMANCE_METRICS_QUERY }
